import { render, staticRenderFns } from "./AddInfo.vue?vue&type=template&id=52ec044e&scoped=true&"
import script from "./AddInfo.vue?vue&type=script&lang=js&"
export * from "./AddInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddInfo.vue?vue&type=style&index=0&id=52ec044e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec044e",
  null
  
)

export default component.exports